/**
 * El arranque de un expediente AR: lo que pasa antes de que el deudor conteste.
 *
 * Lo configura cada empresa —correo, peldaños de WhatsApp con su día y la
 * primera llamada— y lo ejecuta el código, sin el modelo. Ver
 * docs/ar-arranque-plan.md.
 */

/**
 * Días mínimos entre dos peldaños de WhatsApp del arranque.
 *
 * **Es nuestro, no de Meta**: Meta no publica ningún espaciado mínimo. Lo único
 * que sí dice es que lo que cuenta es lo que el usuario bloquea o denuncia, y
 * dos plantillas el mismo día a la misma persona es la forma más directa de
 * conseguirlo. El primer peldaño cuenta desde el alta y puede ser el día 0.
 */
const MIN_TEMPLATE_GAP_DAYS = 7;

/**
 * Cuántas plantillas puede tener la escalera del contacto en frío.
 *
 * Tres mensajes a quien no ha contestado nunca es el techo de lo razonable: el
 * cuarto no recupera más, solo sube la probabilidad de que alguien bloquee el
 * número — y lo que Meta mide es eso.
 *
 * Con este tope y los 7 días, **el cliente monta su escalera sin pedir permiso**:
 * la decisión que antes revisaba ClaimUp ya no tiene margen para hacer daño.
 * Ver docs/escalera-con-topes-plan.md.
 */
const MAX_LADDER_TEMPLATES = 3;

/** Tope de días de un peldaño o de la primera llamada: más allá es un error de tecleo. */
const MAX_DELAY_DAYS = 60;

/**
 * Horas entre intentos de llamada por defecto: las mismas 3,7 h de recobro
 * (`RETRY_SPACING_HOURS`), que dejan tres intentos en la ventana de 9 a 20.
 */
const DEFAULT_CALL_RETRY_HOURS = 3.7;

/**
 * Límites de lo que la empresa puede elegir para un reintento. Por abajo, una
 * hora: menos sería llamar al mismo deudor varias veces en la misma mañana. Por
 * arriba, una semana.
 */
const MIN_CALL_RETRY_HOURS = 1;
const MAX_CALL_RETRY_HOURS = 168;

/** Tope del contador de no-contesta cuando la empresa pone uno. `null` = sin tope. */
const MAX_NO_ANSWER_ATTEMPTS = 50;

/**
 * SMS de AR que pueden salir en un expediente SIN que el deudor haya escrito:
 * los del arranque y los seguimientos. Las respuestas a un SMS suyo no cuentan.
 *
 * Es coste directo de ClaimUp: los SMS salen por nuestra cuenta de BulkGate
 * (Edgar, 19/10/2026: «un techo de 2 SMS por expediente y nada más, y vamos
 * viendo»). Ver docs/ar-sms-plan.md.
 */
const AR_SMS_MAX_OUTBOUND = 2;

/** Lo que cabe en un SMS sin unicode. Más largo, se parte y se cobra cada parte. */
const AR_SMS_MAX_LENGTH = 160;

/** Horario en que sale un SMS del arranque, en Madrid: de lunes a viernes, [desde, hasta). */
const AR_SMS_SEND_FROM_HOUR = 9;
const AR_SMS_SEND_TO_HOUR = 20;

module.exports = {
  MIN_TEMPLATE_GAP_DAYS,
  MAX_LADDER_TEMPLATES,
  MAX_DELAY_DAYS,
  DEFAULT_CALL_RETRY_HOURS,
  MIN_CALL_RETRY_HOURS,
  MAX_CALL_RETRY_HOURS,
  MAX_NO_ANSWER_ATTEMPTS,
  AR_SMS_MAX_OUTBOUND,
  AR_SMS_MAX_LENGTH,
  AR_SMS_SEND_FROM_HOUR,
  AR_SMS_SEND_TO_HOUR,
};
